import styled from "styled-components";
import {
  mediaMaxWidth,
  mediaMinWidth,
} from "../../../theme/mediaQueriesTemplates";

export const Wrapper = styled.div`
  flex: 1 1 calc(33.333% - 80px);
  max-width: calc(33.333% - 13px);
  min-height: 300px;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  padding: 10px;
  border-radius: 8px;
  position: relative;
  box-shadow: rgb(220, 220, 220) 0px 0px 15px;
  margin: 0;
  z-index: 1;
  overflow: hidden;

  &.animated.delay-5 {
    animation-delay: 0.75s;
  }

  ${mediaMaxWidth.mediumDesktop} {
    // width: 650px;
    // margin: 0 auto 10px auto;

    .chart-item {
      display: flex;
      justify-content: center;
    }
  }

  ${mediaMaxWidth.tablet} {
    max-width: calc(100% - 40px);
    // margin: 0 20px 10px 20px;
    margin: 0 20px;
  }

  ${mediaMaxWidth.phone} {
    // margin: 10px 10px 5px 10px;
    max-width: calc(100% - 40px);
    margin: 0 20px;
  }
`;

export const ExportChartWrapper = styled.div`
  display: flex;
  width: 460px;
  flex-direction: column;
  background-color: #fff;
  border-radius: 8px;
  position: relative;
  transform: scale(0.75) translateX(17px) translateY(-10px);
  z-index: 1;
  overflow: hidden;
`;

export const ShowMore = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 20px;
  font-size: 0.9em;
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    color: #79D9D9;
  }

  ${mediaMaxWidth.mediumDesktop} {
    display: none;
  }
`;

export const MobileLegend = styled.div`
  .apexcharts-inner.apexcharts-graphical {
    display: none;
  }

  .apexcharts-legend {
    .apexcharts-legend-series {
      display: flex !important;

      .apexcharts-legend-text {
        margin: 0 4px;
      }
    }
  }

  ${mediaMinWidth.mediumDesktop} {
    display: none;
  }
`;
